function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  } catch {
    return dateStr;
  }
}

function Accomplishments({ accomplishments }) {
  if (!accomplishments || accomplishments.length === 0) {
    return (
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4">
        <h4 className="text-lg font-bold text-gray-800 mb-2">
          {"\uD83C\uDFC6"} Accomplishments
        </h4>
        <p className="text-gray-400 text-sm">
          Keep learning to earn your first accomplishment!
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4">
      <h4 className="text-lg font-bold text-gray-800 mb-3">
        {"\uD83C\uDFC6"} Accomplishments
      </h4>
      <div className="grid grid-cols-2 md:grid-cols-1 gap-2.5">
        {accomplishments.map((item, index) => (
          <div
            key={index}
            className="flex items-start gap-3 p-3 rounded-xl bg-white border border-gray-100"
          >
            <span className="text-2xl flex-shrink-0">{item.icon}</span>
            <div className="flex-1 min-w-0">
              <div className="flex justify-between items-start gap-2">
                <p className="font-semibold text-gray-800 text-sm">
                  {item.title}
                </p>
                <span className="text-xs text-gray-400 flex-shrink-0">
                  {formatDate(item.earned_at)}
                </span>
              </div>
              <p className="text-xs text-gray-500 mt-0.5 text-left">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Accomplishments;
